/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState, useMemo, useCallback, useEffect } from 'react';
import { LayoutBase } from '../../layouts';
import { useNavigate, useParams } from 'react-router-dom';
import { CustomAlert } from '../../components/shared';
import { useAuthContext } from '../../context';
import { formatDate } from '../../services/helpers/helpers';
import { ToolsDetails } from '../../components/custom';
import NewTopioc from '../../components/custom/chats/NewTopic';
import { TopicListInteface, TopicServices } from '../../services/api/chat/topicServices';
import { Box, Divider, IconButton, LinearProgress, Paper, Typography } from '@mui/material';
import { Delete, Send } from '@mui/icons-material';
import { IUser, UserServices } from '../../services/api/users/UserServices';

interface Usuario {
	uuid: string;
	nome: string;
}

export default function ComunicationPage() {
	const { id } = useParams();
	const { userData } = useAuthContext();
	const navigate = useNavigate();
	const [dialogTopic, setDialogTopic] = useState<boolean>(false);
	const [topics, setTopics] = useState<TopicListInteface[]>([]);
	const [loading, setLoading] = useState<boolean>(false);
	const [privado, setPrivado] = useState<boolean>(false);

	console.log(userData.uuid);

	const [users, setUsers] = useState<Usuario[]>([]);
	const [usuariosSelecionados, setUsuariosSelecionados] = useState<string[]>([]);

	const [alertInfo, setAlertInfo] = useState<{ open: boolean; message: string; severity: 'success' | 'error' | 'warning' | 'info' }>({
		open: false,
		message: '',
		severity: 'success'
	});

	const pagePermissionsString: string | undefined = useMemo(() => {
		return userData?.nivel_acesso?.informacoes?.central;
	}, [userData]);

	const hasActionPermission = useCallback((action: 'add' | 'edit' | 'remove' | 'view'): boolean => {
		if (typeof pagePermissionsString === 'string' && pagePermissionsString !== '') {
			const actions = pagePermissionsString.split(',').map(s => s.trim());
			return actions.includes(action);
		}
		return false;
	}, [pagePermissionsString]);

	async function saveTopic(e: string) {
		const data = {
			id_barragem: id ?? '',
			titulo: e,
			notificados: usuariosSelecionados,
			privado: privado
		};
		try {
			await TopicServices.create(data);
			setAlertInfo({ open: true, message: 'Tópico criado !', severity: 'success' });
			id && fetchDataTopic(id);
			setDialogTopic(false);
		} catch (error) {
			setAlertInfo({ open: true, message: 'Erro ao criar tópico !', severity: 'error' });
			console.log('Erro ao criar tópico ', error);
		}
	}

	async function fetchDataTopic(id: string) {
		setLoading(true);
		try {
			const response = await TopicServices.list(id);
			if (response instanceof Error) {
				setAlertInfo({ open: true, message: 'Erro ao buscar tópicos !', severity: 'error' });
				console.log('Erro ao buscar tópicos ', response.message);
			} else {
				let filterData = response;

				filterData = filterData.filter((i) => {
					const userIsNotified = i.notificados?.some((uuid) => uuid === userData.uuid);
					const userIsResponsible = i.id_responsavel === userData.uuid;

					return i.ativo === true && (!i.privado || userIsNotified || userIsResponsible);
				});

				setTopics(filterData);
			}
		} catch (error) {
			setAlertInfo({ open: true, message: 'Erro ao buscar tópicos !', severity: 'error' });
		}
		setLoading(false);
	}

	async function DeletTopic(uuid: string) {
		try {
			await TopicServices.delet(uuid);
			id && fetchDataTopic(id);
			setAlertInfo({ open: true, message: 'Tópico excluido !', severity: 'success' });
		} catch (error) {
			setAlertInfo({ open: true, message: 'Erro ao buscar tópicos !', severity: 'error' });
			console.log('Erro ao buscar tópicos ', error);
		}
	}

	async function fetchUsers() {
		let user;
		try {
			user = await UserServices.get(userData.id_empresa);
			if (user instanceof Error) {
				setAlertInfo({ open: true, message: 'Erro ao buscar usuários !', severity: 'error' });
			} else {
				const filterData = user.filter((i) => i.ativo === true);
				const resFilter = filterData as Usuario[];
				setUsers(resFilter);
			}
		} catch (error) {
			setAlertInfo({ open: true, message: 'Erro ao buscar usuários !', severity: 'error' });
		}
	}

	function onChangeUsuariosSelecionados(usuariosSelecionados: Usuario[]) {
		const listaUUID = usuariosSelecionados.map((i) => i.uuid);
		setUsuariosSelecionados(listaUUID);
	}

	useEffect(() => {
		id && fetchDataTopic(id);
		fetchUsers();
	}, [id]);

	return (
		<LayoutBase
			title='Central de Comunicação - Tópicos'
			tollBar={
				<ToolsDetails
					showSaveButton={false}
					showDeletButton={false}
					showNewButton={pagePermissionsString?.includes('add')}
					onClickNew={() => setDialogTopic(true)}
				/>
			}
		>
			<div style={{ padding: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
				<Typography variant='h5'>Tópicos de conversa</Typography>
				<Divider />
				<div style={{ width: '100%', padding: 2 }}>
					{loading && <LinearProgress />}

					{!loading && !topics?.length && (
						<Box textAlign='center'>
							<Typography variant='body1'>Nenhum tópico encontrado.</Typography>
						</Box>
					)}

					{!loading && topics && topics.length > 0 &&
						<div style={{ width: '100%', padding: 2, display: 'flex', flexDirection: 'column', gap: 5, marginTop: 2 }}>
							{
								topics.map((topico) => (
									<Box
										key={topico.uuid}
										component={Paper}
										variant='elevation'
										sx={{ padding: 2, border: '1px', borderRadius: 2, display: 'flex', flexDirection: 'row', justifyContent: 'space-between', ':hover': { boxShadow: 5 } }}
									>
										<div>
											<Typography variant='subtitle1'><strong>Assunto: {topico.titulo}</strong></Typography>
											<Typography variant='body1'>Criado em: {formatDate(topico.data)}</Typography>
											<Typography variant='body1'>Criado por: {topico.responsavel}</Typography>
										</div>
										<div style={{ display: 'flex', flexDirection: 'column' }}>
											<IconButton title='Chat' onClick={() => navigate(`./${topico.uuid}`)}><Send /></IconButton>
											{userData.uuid == topico.id_responsavel && hasActionPermission('remove') &&
												<IconButton title='Deletar' onClick={() => DeletTopic(topico.uuid)}><Delete /></IconButton>
											}
										</div>
									</Box>
								))
							}
						</div>
					}
				</div>
			</div>

			{/* <NewChat
				close={onClose}
				open={open}
				uuidManutencao={id || ''}
				onCreate={() => setAlertInfo({ message: 'Comentário Criado!', open: true, severity: 'success' })}
				onError={() => setAlertInfo({ message: 'Erro ao criar!', open: true, severity: 'error' })}
				invalid={() => setAlertInfo({ message: 'Preencha o campo de comentário', open: true, severity: 'warning' })} */}
			{/* /> */}
			{users.length > 0 &&
				<NewTopioc
					close={() => setDialogTopic(false)}
					open={dialogTopic}
					save={saveTopic}
					usuarios={users}
					changeSelecionados={onChangeUsuariosSelecionados}
					changePrivado={(e) => setPrivado(e)}
					privado={privado}
				/>
			}
			{alertInfo.open &&
				<CustomAlert
					key={alertInfo.message}
					severity={alertInfo.severity}
					message={alertInfo.message}
				/>
			}
		</LayoutBase>
	);
}